module.exports = __webpack_public_path__ + "media/home/digitizedImagesAccess-x1-5f4832ba.png";